var map = {
	"./ballgas.png": "b73b",
	"./candle.png": "6c09",
	"./chemical.png": "36bd",
	"./engineer123.png": "ef83",
	"./firewall.png": "04bf",
	"./forrul.png": "c302",
	"./fueldispenser.png": "49e1",
	"./headwork.png": "9bc4",
	"./hori.png": "a638",
	"./hotel.png": "69a6",
	"./icon.png": "03c7",
	"./nar.png": "636e",
	"./oilhorizonttank.png": "baca",
	"./oilrailwattank.png": "34df",
	"./oilsimpletank.png": "2809",
	"./oiltrack.png": "e04e",
	"./pipe.png": "a756",
	"./pipeMag.png": "696a",
	"./pipeTech.png": "44f3",
	"./placeholder.png": "58e9",
	"./pump.png": "11ea",
	"./solid.png": "cc64",
	"./tank.png": "c931",
	"./wallPad.png": "6f1d",
	"./worker.png": "627e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";